import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Aos from 'aos';
import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';
import Header from './layout/Header';
import Footer from './layout/Footer';
import AllEvent from './components/AllEvent';
import Event_inner from './components/Event_inner';
import Services from './components/Services';

function App() {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);
  
  return (
    <Router basename="/beta/ReactApp">   
      <Header/> 
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<About/>} />
        <Route path="/contact-us" element={<Contact/>} />
        <Route path="/events" element={<AllEvent/>} />
        <Route path="/event-inner/:name" element={<Event_inner/>} />
        <Route path="/services" element={<Services/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
